<script lang="ts">
  import FormWithLabel from "../../../molecules/FormWithLabel.svelte";
  import type { RecruitmentService } from "../../../services/recruitment.service";

  export let klass = "";
  export let service: RecruitmentService;
  const id = service.storeSearch.id;
  const title = service.storeSearch.title;
  const company = service.storeSearch.company;
  const prefecture = service.storeSearch.prefecture;
  const prefectureOptions = service.storeSearch.prefectureOptions;
</script>

<div class={klass}>
  <div class="flex flex-wrap">
    <div class="flex-1">
      <FormWithLabel
        label="ID"
        input={service.handleSearchId}
        value={$id}
        inputType="number"
        min="1"
      />
    </div>

    <div class="ml-2 flex-1">
      <FormWithLabel
        label="求人名"
        input={service.handleSearchTitle}
        value={$title}
      />
    </div>

    <div class="ml-2 flex-1">
      <FormWithLabel
        label="会社・組織名"
        input={service.handleSearchCompany}
        value={$company}
      />
    </div>

    <div class="ml-2 flex-1">
      <FormWithLabel
        label="都道府県　"
        input={service.handleSearchPrefecture}
        value={$prefecture}
        inputType="select"
        options={$prefectureOptions}
      />
    </div>
  </div>
</div>
